import { createSlice } from "@reduxjs/toolkit";

// Product Details View Enum
export const CURRENT_PRODUCT_DETAILS_VIEW = {
  PRODUCT_BRIEF_INTRO_SCREEN: "productBriefIntroScreen",
  PRODUCT_DETAILS_SCREEN: "productDetailsScreen",
};

// Initial state
const initialState = {
  selectedGtinID: null,
  currentView: CURRENT_PRODUCT_DETAILS_VIEW.PRODUCT_BRIEF_INTRO_SCREEN,
};

// Slice
const productDetailsSlice = createSlice({
  name: "productDetails",
  initialState,
  reducers: {
    // Set current view
    setCurrentProductDetailsView: (state, action) => {
      state.currentView = action.payload;
    },
    setSelectedGtinID: (state, action) => {
      state.selectedGtinID = action.payload;
    },
    // Reset to initial state
    resetProductDetails: () => initialState,
  },
});

// Export actions
export const {
  setCurrentProductDetailsView,
  resetProductDetails,
  setSelectedGtinID,
} = productDetailsSlice.actions;

// Export selectors
export const selectSelectedGtinID = (state) =>
  state.productDetails?.selectedGtinID;
export const selectCurrentProductDetailsView = (state) =>
  state.productDetails?.currentView;

// Export reducer
export default productDetailsSlice.reducer;
